import cn from 'classnames';

import { usePlayback } from '../context/PlaybackContext';
import CondensedControls, {
  CondensedControlsProps,
} from './baseControls/CondensedControls';
import styles from './PlayerCondensedControls.module.scss';

export interface PlayerCondensedControlsProps
  extends Pick<
    CondensedControlsProps,
    | 'ariaVideoTitle'
    | 'buttonClassName'
    | 'endedContent'
    | 'endedStrategy'
    | 'icon'
    | 'size'
  > {
  className?: string;
}

// connects CondensedControls to the PlaybackContext so that they can be easily
// passed to the Player
const PlayerCondensedControls: React.FC<PlayerCondensedControlsProps> = ({
  ariaVideoTitle,
  buttonClassName,
  endedContent,
  endedStrategy,
  icon,
  size,
  className,
}) => {
  const { ready, onTogglePlay, playbackState } = usePlayback();

  return (
    <CondensedControls
      className={cn(className, styles.controls, {
        [styles.controls__visible]:
          playbackState !== 'playing' ||
          (playbackState === 'playing' && !ready),
      })}
      loading={!ready}
      onClick={onTogglePlay}
      status={playbackState}
      {...{
        ariaVideoTitle,
        buttonClassName,
        endedContent,
        endedStrategy,
        icon,
        size,
      }}
    />
  );
};

export default PlayerCondensedControls;
